// medflow_admin is a superset of both admin and customer_admin:
// any permission check for either role automatically passes for
// medflow_admin. customer_admin is a separate central-hub role
// and does NOT inherit admin — it has its own explicit grants.
const ROLE_INHERITS = {
    medflow_admin: ['admin', 'customer_admin'],
};
export function roleSatisfies(userRole, allowedRoles) {
    if (allowedRoles.includes(userRole))
        return true;
    const inherited = ROLE_INHERITS[userRole];
    return inherited ? inherited.some((r) => allowedRoles.includes(r)) : false;
}
//# sourceMappingURL=index.js.map